<template>
  <div class="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6 relative overflow-hidden text-white font-sans">
    <div class="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-romance-red/10 blur-[120px] rounded-full"></div>

    <div class="max-w-md w-full z-10">
      <div class="text-center mb-10">
        <img src="@/assets/logo_red_2.png" class="mx-auto h-24 w-auto mb-4">
        <h2 class="text-3xl font-black uppercase italic italic tracking-tighter">¿Perdiste tu contraseña?</h2>
        <p class="text-gray-500 mt-2">Ingresá tu correo y te enviaremos un acceso nuevo.</p>
      </div>

      <form @submit.prevent="handleRequestLink" class="space-y-6">
        <div>
          <label class="block text-[10px] font-black uppercase tracking-widest text-gray-400 mb-2 ml-2">Correo Electrónico</label>
          <input v-model="email" type="email" placeholder="tu-correo@ejemplo.com" required
                 class="w-full p-4 bg-white/5 border border-white/10 rounded-2xl focus:ring-2 focus:ring-romance-red outline-none transition-all">
        </div>

        <button type="submit" :disabled="loading"
                class="w-full py-5 bg-romance-red text-white font-black rounded-2xl shadow-xl shadow-romance-red/20 hover:brightness-110 active:scale-95 transition-all uppercase italic tracking-widest">
          {{ loading ? 'Enviando...' : 'Enviar enlace' }}
        </button>
      </form>

      <div class="mt-8 text-center">
        <router-link to="/signin" class="text-sm font-bold text-gray-500 hover:text-white transition">← Volver al inicio</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import api from '@/api'
import Swal from 'sweetalert2'

const email = ref('')
const loading = ref(false)

const handleRequestLink = async () => {
  loading.value = true
  try {
    // Este endpoint debe manejar la generación del token y envío del mail
    await api.post('/password/request', { email: email.value })

    Swal.fire({
      icon: 'success',
      title: '¡Enlace enviado!',
      text: 'Revisá tu bandeja de entrada (y el spam por si acaso).',
      confirmButtonColor: '#ec4899',
      customClass: { popup: 'rounded-[2rem]' }
    })
  } catch (err) {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: err.response?.data?.error || 'No pudimos procesar la solicitud.',
      confirmButtonColor: '#ef4444'
    })
  } finally {
    loading.value = false
  }
}
</script>